/**
 * Sets a CSS custom property on :root from a section wrapper height.
 * Use data-doc-root-height-var on an element inside the section (e.g. height-observer).
 */
(function () {
  'use strict';

  function apply(el) {
    var varName = el.getAttribute('data-doc-root-height-var');
    if (!varName) return;
    var section = el.closest('[id^="shopify-section-"]');
    if (!section) return;
    document.documentElement.style.setProperty(varName, section.clientHeight.toFixed(2) + 'px');
  }

  function run() {
    document.querySelectorAll('[data-doc-root-height-var]').forEach(apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
